import React, { Component } from 'react'
import { GoogleMap, withGoogleMap, withScriptjs, Marker } from 'react-google-maps'
import firebase from 'firebase';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import { relative } from 'path';
import { withAlert } from "react-alert";

const database=firebase.database();

class Map extends Component {

  constructor(props) {
    super(props);
    this.state = {
       showMarker: this.props.showMarker, coordenadas: this.props.coordenadas,
       bases:[],
			baseKey:this.props.baseKey,
			nombre:this.props.nombre,
			descripcion:this.props.descripcion,
			foto:this.props.foto,
			latitud:this.props.latitud,
			longitud:this.props.longitud,
			direccion:this.props.direccion,
			isActive:false,
			uploadValue:0,
			files:null,
			template:false,
			estado:this.props.estado
     }
    this.handleClickAlerta=this.handleClickAlerta.bind(this);
		this.submitUpdate=this.submitUpdate.bind(this);
		this.handleUpload=this.handleUpload.bind(this);
		
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
			handleClose,

		}) => {
		const handleConfirm = () => {
			this.submitUpdate();
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={{position: 'absolute'}}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton2 btn btn-success btn-alerts btn-m-r" onClick={this.props.close}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
	}

	


	handleClickAlerta(event){
		if(this.props.guardar!==true)
		{
			this.props.alert.success(
				<div >
				<button style={{color:'black', width:'90%', margin:5, backgroundColor:'transparent', borderColor:'transparent', textAlign:'center'}} onClick={() =>this.submitUpdate()}>Guardar</button>
				</div>
			);
		}
		else{
			this.submitUpdate()
		}
		event.preventDefault();
	}

	componentWillMount = ()  =>{
		if(this.props.guardar===true){
			this.setState({	coordenadas: { lat: 13.7011184, lng:-89.2451413 } ,latitud:13.7011184, longitud:-89.2451413 })
		}
	}


  setMarker(e) {
    let lat = e.latLng.lat();
    let lng = e.latLng.lng();
		this.setState({ showMarker: true,
			latitud:lat,longitud:lng,
			coordenadas: { lat: Number(lat.toFixed(6)), lng: Number(lng.toFixed(6)) } })
	}
	
  
  submitUpdate(){
		
		
		//Clave de el nodo de base
		let key=this.state.baseKey;
		
		let nombre=this.state.nombre;
		let descripcion=this.state.descripcion;
		let direccion=this.state.direccion;
		let latitud = this.state.latitud;
		let longitud = this.state.longitud
		let estado = this.estado.value
		
		
		
		//Archivo de la imagen
		let archivo=this.state.files;
		
		if(archivo===null && this.props.guardar!==true){
				
			database.ref('Bases').child(key).update({
				
						Nombre:nombre,
						Descripcion:descripcion,
						direccion,
						latitud,
						longitud,
						estado
				});
				this.props.cerrar;
				this.props.alert.success('Datos actualizados correctamente');				
				setTimeout(() => {
					try{
					document.getElementById("btnCerrar").click();
					}
					catch(e){

					}
				}, 1500);
			
		}else{
		

			//Referencia al storage
			const storageRef = firebase.storage().ref(`Bases/${archivo.name}`);
			
			const task= storageRef.put(archivo);
			
			
			task.on('state_changed', snapshot =>{
			
			
			this.setState({
			  uploadValue :50,
			})

			}, error =>{ console.log(error.message);
			},
			()=>{
				

				if(this.props.guardar!==true)
				{

				database.ref('Bases').child(key).update({
				
						Nombre:nombre,
						Descripcion:descripcion,
						foto:task.snapshot.downloadURL,
						direccion,
						latitud,
						longitud,
						estado
			   
				})	
		
				
				this.setState({
					uploadValue:100,
					urlFoto:task.snapshot.downloadURL
				});
				
				this.props.cerrar;
				this.props.alert.success('Datos actualizados correctamente');
				setTimeout(() => {
					try{
					document.getElementById("btnCerrar").click();
					}
					catch(e){
						
					}
				}, 1500);
			}
			else{
				database.ref('Bases').push({
			
						Descripcion:descripcion,
						Nombre:nombre,
						latitud,
						longitud,
						foto:task.snapshot.downloadURL,
						direccion,
						estado
				});	
		
				
				this.setState({
					uploadValue:100,
					urlFoto:task.snapshot.downloadURL
				});
				this.setState({baseKey:"",
				nombre:"",
				foto:"",
				descripcion:"",
				latitud:"",
				longitud:"",
				direccion:""})
				this.props.alert.success('Datos guardados correctamente');
				setTimeout(() => {
						try{
						document.getElementById("btnCerrar").click();
						}
						catch(e){
							
						}
				}, 1500);
				}	
			});
		}
		
	}

	handleUpload(e,filee){
		
		var file= e.target.files[0],
		pattern= /image-*/,
		reader=new FileReader();
		
		if(file===undefined){
			
			this.setState({ 
				 foto:null,
				 files:null
			}); 
			
		}
		else{
			
			if(!file.type.match(pattern)){
			
					Alert.error('Por favor ingresa una imagen con formato valido', {
						effect: 'genie',
						position: 'bottom-right',
						timeout:2000			
					});
					return;
				}
		


				reader.onload = (e) => {
					this.setState({ 
						foto:reader.result,
						files:file
					}); 
				}		
			
				reader.readAsDataURL(file);			
		}
	}


	//LLenar textbox
	handleChangeNombre = (event) =>{
		this.setState({nombre: event.target.value});
	}

	handleChangeDireccion = (event) =>{
		this.setState({direccion: event.target.value});
	}

	handleChangeDescripcion = (event) =>{
		this.setState({descripcion: event.target.value});
	}
	handleChangeEstado = (input) =>{
		this.setState({estado:input});
		console.log(input)
	}

  render() {
    const { showMarker, coordenadas } = this.state;

    return (
      <div className="map" onClick={this.ocultarMenu}>
      <form method="POST" action="" onSubmit={this.handleClickAlerta
				}>
      
        <div className="form-group">
          <label htmlFor="nombre">Nombre:</label>
          <input type="text" className="form-control" placeholder="Nombre"
            onChange={this.handleChangeNombre} 
            required autoComplete="off"
            defaultValue={this.state.nombre}
          />
        </div>

        <div className="form-group">
          <label htmlFor="descripcion">Descripcion:</label>
          <textarea className="form-control" name="descripcion" placeholder="Descripcion"
             onChange={this.handleChangeDescripcion}  autoComplete="off"
            defaultValue={this.state.descripcion}
          ></textarea>
        </div>
        <div className="form-group">
          <label htmlFor="direccion">Direccion:</label>
          <textarea className="form-control" name="direccion" placeholder="Direccion"
            onChange={this.handleChangeDireccion}  autoComplete="off"
            defaultValue={this.state.direccion}
          ></textarea>
        </div>
				<div className="form-group">
						<label htmlFor="estado">Estado</label>
						<select name="estado" className="form-control"
						ref={input => {this.estado=input;}}
						defaultValue={this.state.estado}
						>
							<option value="activa">Activo</option>
							<option value="inactiva">Inactivo</option>
						</select>
					</div>
        <GoogleMap
          defaultZoom={15}
          defaultCenter={coordenadas}
          onClick={this.setMarker.bind(this)}>
          {showMarker && <Marker position={coordenadas} 
					/>}

        </GoogleMap>
        <div className="form-group">
          <label htmlFor="foto">Foto de la base</label>
          <br />
          <progress value={this.state.uploadValue} max="100"></progress>
          <input type="file" className="form-control" onChange={this.handleUpload} />
        </div>
        <img src={this.state.foto} alt="Foto base" className="foto" width="240px" />
        <button type="submit" className="btn btn-primary buttons" >Guardar</button>
				<button id='btnCerrar' type="button" className="btn btn-default buttons  btnmargin" onClick={this.props.toggleModal}>Cerrar</button>
      </form>
			</div>
    );
  }
}



export default withScriptjs(withGoogleMap(withAlert(Map)));



// WEBPACK FOOTER //
// ./src/Components/Bases/mapa.js